import React from "react";
import { useCss, a } from "kremling";

type CpEmptyStateProps = {
  className?: string;
  cta?: React.ReactNode;
  img: string;
  subText?: string;
  text?: string;
  [key: string]: any;
};

export function CpEmptyState({
  className,
  cta,
  img,
  subText,
  text,
  ...rest
}: CpEmptyStateProps) {
  const scope = useCss(css);
  const iconSource = getIconSource(img);
  return (
    <div {...scope} className={a("cp-empty-state").a(className)} {...rest}>
      <div className="cp-empty-state__inner">
        <div
          style={{ backgroundImage: `url(${iconSource})` }}
          aria-label={img}
          className="cp-empty-state__img"
          data-testid="cp-empty-state-img"
        />
        {text && <div className="cp-empty-state__text">{text}</div>}
        {subText && <div className="cp-empty-state__subText">{subText}</div>}
        {!!cta && <div className="cp-empty-state__cta">{cta}</div>}
      </div>
    </div>
  );
}

function getIconSource(img: string): string {
  if (!img) return "";
  return hasImageExtension(img)
    ? img
    : `https://cdn.canopytax.com/static/empty-states/${encodeURIComponent(
        img,
      )}.svg`;
}

function hasImageExtension(img: string): boolean {
  return Boolean(/\.(png|jpe?g|gif|webp|svg)(\?.*)?$/.test(img.toString()));
}

const css = `
  .cp-empty-state {
    max-width: 40rem;
    margin: 0 auto;
  }

  .cp-empty-state__inner {
    text-align: center;
  }

  .cp-empty-state__img {
    width: 8rem;
    height: 8rem;
    display: inline-block;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  .cp-empty-state__text {
    font-size: 1.4rem;
    font-weight: 700;
  }

  .cp-empty-state__subText {
    padding-top: .4rem;
    color: var(--cps-color-cool-gray);
    white-space: normal;
  }

  .cp-empty-state__cta {
    padding-top: 1.2rem;
  }

`;
